import { Injectable } from '@angular/core';
import { Config } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FileConversionService {

  // Office file extensions
  static readonly OFFICE_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'odt', 'ods', 'odp'];

  // Uppy allowedFileTypes for Office documents
  static readonly OFFICE_FILE_TYPES = [
    '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.odt', '.ods', '.odp',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.presentation',
  ];

  // File validation regex pattern for onBeforeFileAdded
  static readonly ALLOWED_FILE_REGEX = /\.(gif|jpg|jpeg|png|pdf|doc|docx|xls|xlsx|ppt|pptx|odt|ods|odp)$/i;

  /**
   * Check if a file is an Office document that needs PDF conversion
   */
  isOfficeFile(fileName: string): boolean {
    return /\.(doc|docx|xls|xlsx|ppt|pptx|odt|ods|odp)$/i.test(fileName);
  }

  /**
   * Convert an Office file to PDF using the Companion server
   */
  async convertToPdf(file: { data: Blob; name: string }): Promise<Blob> {
    const formData = new FormData();

    if (file.data instanceof Blob) {
      formData.append('file', file.data, file.name);
    } else {
      throw new Error('File data is not available for conversion');
    }

    const response = await fetch(`${Config.COMPANION_URL}/convert/pdf`, {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Conversion failed: ${response.status} ${errorText}`);
    }

    return response.blob();
  }

  /**
   * Get PDF filename from original Office filename
   */
  getPdfFileName(originalName: string): string {
    const ext = originalName.match(/\.[^.]+$/)?.[0] || '';
    return originalName.replace(ext, '.pdf');
  }
}
